import React from 'react';
import style from './new-message-indicator.module.css';

interface Props {
    onClick():void;
    newMessages: number;
}

const NewMessageIndicator: React.FC<Props> = ({ onClick, newMessages }) => {

    return (
        <button onClick={onClick} type="button" className={style.newMessageButton}>
            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.55514 0.854837L6.9721 5.27131L11.4555 0.942341C11.8203 0.590115 12.3974 0.596079 12.7501 0.961311C13.1004 1.32401 13.0929 1.8995 12.7239 2.2558L7.6485 7.15708C7.43094 7.36718 7.13779 7.44984 6.86178 7.40482C6.6418 7.39563 6.42387 7.30583 6.25312 7.13507L1.26401 2.14596C0.905471 1.78743 0.901361 1.21023 1.26038 0.85121C1.61692 0.494675 2.19244 0.492145 2.55514 0.854837Z" fill="#092A5E" />
            </svg>

            <div className={style.newMessage}>
                <span>{newMessages}</span>
            </div>
        </button>
    )
}

export default NewMessageIndicator;